var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[(_vm.status === 'loading')?_c('k-spinner',{attrs:{"height":"500px"}}):_c('block-list-table',{attrs:{"items":_vm.blocks,"is-global":_vm.isGlobal}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }